// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { any, string } from "@altostra/type-validations/lib/primitives";

const isGroup = objectOf({
  name: string,
  description: maybe(string),
  icon: maybe(string),
  items: arrayOf(any),
});

export const isEngagementFilterGroupsResult = objectOf({
  filter_groups: arrayOf(isGroup),
});
